/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../../http/http';
import { success, error } from '../../../../../services/alert-message';

const urlApi = 'central/api/v1/atos';

/**
* Buscando todos atos
* @param {*} param0
*/
export async function imagemGet({ commit }, obj) {
  Loading.show();
  // const consulta = JSON.parse(JSON.stringify(obj));
  if (!obj.termoConsultado) {
    obj.termoConsultado = 'Pesquisa avançada';
  }
  return (await http.post(`${urlApi}/${obj.ato_id}/arquivo`, obj)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
